import { AxiosInstance, AxiosStatic } from 'axios'
import { ApiRoutesNames } from 'bets.oddprovider.lib.common.ts/api/routes'
import { ICompany } from 'bets.oddprovider.lib.common.ts/models'
import { BaseApiClient } from 'fwork-jsts-common/src/apiClient'
import { WhereOptions } from 'sequelize'
import { store } from '../redux/store'

export class CompaniesApiClient extends BaseApiClient<ICompany, any, WhereOptions<ICompany>, ICompany, ICompany> {
  constructor(axios: AxiosStatic | AxiosInstance) {
    const dotEnvProductionState = store.getState().dotEnvProductionState
    const baseUrl = `${dotEnvProductionState.payload?.APIURL}${ApiRoutesNames.companies}`
    super({
      apiUrl: baseUrl,
      axios,
    })
  }
}